module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Light-13d61ef8e609b548d9b5bd989141e829.ttf";